export default "/images/552caad2a715b270fe1c724baf0c2cc4.avif";